export const TutorialsPanel = {
  CaptionTitle: {
    Text: {
      text: '{{ learn.docs.title | polyglot }}'
    }
  },
  DocsSidebar: {
    top: 'auto',
    padding: '0',
    fontSize: 'Z2',
    gap: 'A2',
    childProps: {
      position: 'relative',
      padding: '- 0',
      NumbCaption: {
        Numb: null,
        SquareButton: {
          padding: 'X'
        }
      }
    }
  },
  flow: 'y',
  gap: 'A'
}
